import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { LibraryService } from '../providers/library.services';
import { CurrentUser } from "../../common/providers/current-user";
import { Observable, switchMap } from "rxjs";
import { Library } from "../../common/models/library";
import { ApiBaseService } from "../../common/providers/api-base-service";
import { Exercice } from "../../common/models/exercice";
import { ExercicesProvider } from "../../exercices/providers/exercices-provider";
import { OrganizationsProvider } from "../../organizations/providers/organizations-provider";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class LibrariesFromOrganizationResolver implements Resolve<Library[]> {
    constructor(
        private exercicesProvider: ExercicesProvider,
        private organizationsProvider: OrganizationsProvider,
        public currentUser: CurrentUser,
        public api : ApiBaseService
    ) { }

    public resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<Library[]> {
      return this.organizationsProvider.getByCode(route.params["organizationCode"]).pipe(
        switchMap((organization) => {
          return this.exercicesProvider.getLibraries(organization.id!);
        }),
      );
    }
}
